// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = "/dashboard";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  login: "/login",
  registration: "/registration",
  forgotPassword: "/forgot-password",
  otpVerify: "/otp-verify",
  ChangePassword: "/change-password",
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  dashboard: path(ROOTS_DASHBOARD, "/dashboard"),
  deposits: path(ROOTS_DASHBOARD, "/deposits"),
  withdraw: path(ROOTS_DASHBOARD, "/withdraw"),
  invitations: path(ROOTS_DASHBOARD, "/invitations"),
  commissions: path(ROOTS_DASHBOARD, "/commissions"),
  thirdPartyAddress: path(ROOTS_DASHBOARD, "/thirdPartyAddress"),
  profile: path(ROOTS_DASHBOARD, "/profile"),
  // user: {
  //   root: path(ROOTS_DASHBOARD, "/user"),
  //   four: path(ROOTS_DASHBOARD, "/user/four"),
  //   five: path(ROOTS_DASHBOARD, "/user/five"),
  //   six: path(ROOTS_DASHBOARD, "/user/six"),
  // },
};
